<template>
  <div class="antialiased text-premium-text bg-premium-bg selection:bg-brand-500/30 selection:text-brand-200">
    <AppNavbar />
    <main class="relative min-h-screen">
      <router-view />

      <!-- Global Loader -->
      <transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="$store.state.loading"
          class="fixed inset-0 bg-premium-bg/80 backdrop-blur-sm flex items-center justify-center z-[100]"
        >
          <div class="relative flex flex-col items-center gap-4">
            <div class="w-12 h-12 border-2 border-brand-500/20 border-t-brand-500 rounded-full animate-spin"></div>
          </div>
        </div>
      </transition>
      <!-- Global Toast -->
      <AppToast
        v-if="toastState.show"
        :message="toastState.message"
        :type="toastState.type"
        :duration="toastState.duration"
        @close="hideToast"
      />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import AppNavbar from "./components/appNavbar.vue";
import AppFooter from "./components/appFooter.vue";
import AppToast from "./components/ui/AppToast.vue";
import { useToast } from "./composables/useToast";

export default defineComponent({
  components: {
    AppNavbar,
    AppFooter,
    AppToast,
  },
  setup() {
    const { toastState, hideToast } = useToast();
    return {
      toastState,
      hideToast,
    };
  },
});
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

:root {
  color-scheme: dark;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  background-color: #050505;
}

#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #000;
}

::-webkit-scrollbar-thumb {
  background: #222;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #333;
}
</style>
